// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__31WTH","entriesText":"Pagination_entriesText__3uexK","paginationWrapper":"Pagination_paginationWrapper__mNecT"};